import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faBolt, faCar, faGasPump, faLightbulb, faMobile, faSmog, faTree, faTruck, } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CarbonEmissionsIcon',
    props: {
        icon: null
    },
    setup(__props) {
        const props = __props;
        library.add(faBolt, faCar, faGasPump, faLightbulb, faMobile, faSmog, faTree, faTruck);
        return { __sfc: true, props, FontAwesomeIcon };
    }
});
